<div class="p-6.5">
    <div class="flex justify-end pb-6.5">
        <mat-icon class="close cursor-pointer" [svgIcon]="SvgIcon.CROSS" (click)="cancel()"></mat-icon>
    </div>
    <div class="flex h-full flex-col items-center">
        <span class="malou-text-16--bold mb-3 text-center">
            {{ 'maloupe.diagnostic_search.common.modal.place_details_rate_limit_error' | translate }}
        </span>
        <span> {{ 'maloupe.diagnostic_search.common.modal.place_diagnostic_rate_limit_try_later' | translate }} </span>

        <button class="malou-btn-flat mt-10 w-16 sm:mt-8" mat-flat-button (click)="cancel()">ok</button>
    </div>
</div>
